import PropTypes from 'prop-types'
import React from 'react'

const PageContent = ({ style = '', noHeader = false, children }) => {
  let noHeaderStyle = ' '

  if (noHeader) {
    noHeaderStyle = ' no-header '
  }
  const styleName = `container page-content${noHeaderStyle}${style}`

  return <div className={styleName}>{children}</div>
}

PageContent.propTypes = {
  theme: PropTypes.string,
  style: PropTypes.string,
  noHeader: PropTypes.bool,
  children: PropTypes.node,
}

export default PageContent
